import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "galery"
}
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "navigation-wrapper" }
const _hoisted_4 = { class: "carousel__item" }
const _hoisted_5 = { class: "circle-image" }
const _hoisted_6 = ["src", "onClick", "alt"]
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "position" }
const _hoisted_9 = { class: "zone" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_Slide = _resolveComponent("Slide")!
  const _component_Carousel = _resolveComponent("Carousel")!

  return (_ctx.galleryImages.length > 0)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Carousel, {
            class: _normalizeClass('winner'),
            breakpoints: _ctx.breakpoints,
            "wrap-around": false
          }, {
            addons: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_Navigation)
              ])
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.galleryImages, (slide, index) => {
                return (_openBlock(), _createBlock(_component_Slide, { key: index }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slide.files, (image) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createElementVNode("img", {
                            src: image.url,
                            class: "",
                            onClick: ($event: any) => (_ctx.showGallery(index)),
                            alt: image.name
                          }, null, 8, _hoisted_6)
                        ]))
                      }), 256)),
                      _createElementVNode("p", _hoisted_7, _toDisplayString(slide.name), 1),
                      _createElementVNode("p", _hoisted_8, _toDisplayString(slide.position), 1),
                      _createElementVNode("p", _hoisted_9, _toDisplayString(slide.category), 1)
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["breakpoints"])
        ])
      ]))
    : _createCommentVNode("", true)
}